import React, { ReactElement } from 'react';
import Link from 'next/link';
import classNames from 'classnames/bind';

import RootLayout from 'layouts/RootLayout';
import Breadcrumbs from 'components/Breadcrumbs';

import styles from 'pages/auth/sign-in/greetings/Greetings.module.scss';

const cn = classNames.bind(styles);

export default function Greetings(): ReactElement {
  return (
    <div className={cn('greetings')}>
      <div className={cn('container')}>

        <Breadcrumbs
          mTop={64}
          mode="dark"
          links={[{ title: 'Greetings', href: '/' }]}
        />

        <h1 className={cn('greetings__heading')}>
          Dear Members, Greetings from DFA Team!
        </h1>

        <div className={cn('greetings__info')}>
          <p className={cn('greetings__paragraph')}>
            We welcome you to our first unique DFA group for premium members only.
            We created it with the aim of making you closer to each other.
            You can communicate and place business requests here,
            as well as present your companies and grow your business!
          </p>

          <p className={cn('greetings__paragraph')}>
            Not all the premium members are here, but we are working on expanding chat activity.
            Still, all the details for other members can be found in the{' '}
            <Link
              className={cn('greetings__link')}
              href="/directory"
            >
              DFA Directory
            </Link>
            .
          </p>

          <p className={cn('greetings__paragraph')}>
            We encourage you to pass the next survey to help us better understand your companies.
            This is for our internal data. Follow the next link to get it:{' '}
            <Link
              className={cn('greetings__link')}
              href="/feedback/events-survey/survey-to-improve-experience"
            >
              Survey to Improve Experience
            </Link>
            .
          </p>

          <p className={cn('greetings__paragraph')}>
            If you can’t find here the agent for your logistics needs,
            you can always place your requests in{' '}
            <Link
              className={cn('greetings__link')}
              href="https://www.searates.com/"
            >
              www.searates.com
            </Link>
            , and we will ensure all types of transportation with the help of our members.
          </p>

          <p className={cn('greetings__paragraph')}>
            Please follow these general chat etiquette rules:
          </p>

          <ul className={cn('greetings__rules')}>
            <li className={cn('greetings__rules-item')}>
              do not add people without asking for permission. This chat was created
              for premium members only, 1-2 persons from each company maximum;
            </li>
            <li className={cn('greetings__rules-item')}>
              no Spam;
            </li>
            <li className={cn('greetings__rules-item')}>
              don’t blow up people’s phones at night. Please consider the time difference
              of other members;
            </li>
            <li className={cn('greetings__rules-item')}>
              avoid using ALL CAPS and too many Emojis;
            </li>
            <li className={cn('greetings__rules-item')}>
              don’t send phishing links and malicious attachments;
            </li>
            <li className={cn('greetings__rules-item')}>
              please remember that all business communication is better done through the mail.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export const getStaticProps = async () => {
  return {
    props: {
      title: 'DF Alliance',
      description: 'Digital Freight Alliance',
      path: '/auth/sign-in/greetings',
    },
  };
};

Greetings.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
